module.exports = __webpack_public_path__ + "static/img/bg5.50264df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg5.jpg
// module id = 99Q4
// module chunks = 1